import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { StoryCard } from 'legacyComponents/cards/types/story';

@withNamespaces()
@inject('routerStore')
@observer
export class ChannelStories extends React.Component {
  render() {
    const { stories } = this.props;

    return (
      <CardSection
        title='Stories'
        tooltip='Create new story'
        updateHeader
        index={2}
        isChannel
        ownerName=''
        cardApp={stories}
        CardComponent={StoryCard}
        noDataCardType='story'
        gridColumns={2}
        noCount
      />
    );
  }
}

ChannelStories.propTypes = {
  stories: PropTypes.object,
};
